import { render } from "./MadeByComponent.vue?vue&type=template&id=67300606"
import script from "./MadeByComponent.vue?vue&type=script&lang=js"
export * from "./MadeByComponent.vue?vue&type=script&lang=js"

import "./MadeByComponent.vue?vue&type=style&index=0&id=67300606&lang=scss"
script.render = render

export default script